@import (reference) '../../../styles/variables.less';
@import (reference) '../../../styles/functions.less';
@import (reference) '../../../styles/buttons.less';
@import (reference) '../../../styles/themes.less';
@import (reference) '../../../styles/input.less';
@import (reference) '../../../styles/select.less';

:host {
  container-name: main;
  container-type: inline-size;
  display: block;
  font: @lt-font-primary;
}

.theme-white {
  .theme-white();
}

.theme-blue-light {
  .theme-blue-light();
}

.theme-blue-deep {
  .theme-blue-deep();
}

.theme-teal {
  .theme-teal();
}

.h1,
.h3 {
  margin: 0;
  padding: 0;
}

.h1 {
  font: @lt-font-secondary;
  .font-size-em(24);
  .line-height(30, 24);

  @container main (width >=@container-sm) {
    .font-size-em(28);
    .line-height(36, 28);
  }

  @container main (width >=@container-md) {
    .font-size-em(34);
    .line-height(41, 34);
  }
}

.h3 {
  font-weight: bold;
  .font-size-em(21);
  .line-height(30, 21);

  @container main (width >=@container-sm) {
    .font-size-em(24);
    .line-height(29, 24);
  }

  @container main (width >=@container-md) {
    .font-size-em(27);
    .line-height(36, 27);
  }
}

ltc-input-text {
  color: @lt-blue-deep;

  label {
    color: @lt-gray-dark-2;
  }
}

.container {
  background-color: var(--background-color);
  border-radius: @spacer-2;
  box-shadow: @shadow-1;
  color: var(--font-color);
  display: block;
  margin: 0 auto;
  max-width: @container-max;
  padding: @spacer-3;
}

.cta-btn {
  .button-common();
  .button-size-medium();

  align-self: center;
  background-color: var(--btn-color);
  box-shadow: var(--btn-border) var(--btn-color-border);
  color: var(--btn-text);
  height: 41px;

  &:hover {
    background-color: var(--btn-color-hover);
    box-shadow: var(--btn-border-hover) var(--btn-color-border-hover);
  }

  &:focus {
    background-color: var(--btn-color-focus);
    box-shadow: var(--btn-border-focus) var(--btn-color-border-focus);
  }

  &:disabled {
    background-color: @lt-gray-light-2;
    color: @lt-gray-dark-2;
  }
}

header {
  color: var(--font-head-color);
  text-align: left;

  @container main (width >=@container-md) {
    text-align: center;
  }
}

.select-with-label {
  .select-with-float-label();
}

.form-container {
  display: grid;
  gap: @spacer-3;
  grid-template: "type type" "amount zip" "cta cta" / 1fr 1fr;
  padding-bottom: @spacer-3;
  padding-top: @spacer-3;

  @container main (width >=@container-sm) {
    grid-template: "type amount zip" ". cta ." / 1fr 1fr 1fr;
  }

  @container main (width >=@container-md) {
    grid-template: "type amount zip cta" / 1fr 1fr 1fr 1fr;
  }

  &.no-loan-select {
    grid-template: "amount zip" "cta cta" / 1fr 1fr;

    @container main (width >=@container-sm) {
      grid-template: "amount zip cta" / 1fr 1fr 1fr;
    }

    @container main (width >=@container-md) {
      grid-template: ". amount zip cta ." / 0.3fr 1fr 1fr 1fr 0.3fr;
    }
  }

  &.no-zip-input {
    grid-template: "type amount" "cta cta" / 1fr 1fr;

    @container main (width >=@container-sm) {
      grid-template: "type amount cta" / 1fr 1fr 1fr;
    }

    @container main (width >=@container-md) {
      grid-template: ". type amount cta ." / 0.3fr 1fr 1fr 1fr 0.3fr;
    }
  }

  &.no-zip-input.no-loan-select {
    grid-template: "amount" "cta" / 1fr;

    @container main (width >=@container-sm) {
      grid-template: ". amount cta ." / 0.3fr 1fr 1fr 0.3fr;
    }

    @container main (width >=@container-md) {
      grid-template: ". amount cta ." / 0.6fr 1fr 1fr 0.6fr;
    }
  }

  .select-with-label {
    grid-area: type;
  }

  .loan-amount {
    grid-area: amount;
  }

  .zip-code {
    grid-area: zip;
  }

  .cta-btn {
    grid-area: cta;
  }
}

footer {
  align-items: center;
  display: flex;
  justify-content: center;
}
